module.exports = __webpack_public_path__ + "static/media/benequer1.142c2549.jpg";